<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex xs12 md9>
        <material-card color="green" title="用户信息" text="更改用户密码">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <v-avatar slot="offset" class="mx-auto d-block" size="130">
                <img :src="user.avatarUrl">
              </v-avatar>
              <h4 class="card-title font-weight-light">{{user.nickName}}</h4>
              <h6 class="category text-gray font-weight-thin mb-3">{{user.mobile}}</h6>
            </v-flex>
          </v-layout>

          <v-form v-model="valid">
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    type="password"
                    label="旧密码"
                    v-model="oldPassword"
                    :rules="[rules.required, rules.password]"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    type="password"
                    label="新密码"
                    v-model="newPassword"
                    :rules="[rules.required, rules.password]"
                  />
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    type="password"
                    label="再次输入密码"
                    v-model="retypePassword"
                    :rules="[rules.required, retypePasswordRule]"
                  />
                </v-flex>
                <v-flex xs12 text-xs-right>
                  <v-btn
                    class="mx-0 font-weight-light"
                    color="success"
                    :disabled="!valid"
                    @click="save"
                  >更改</v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import global from '@/global'
import md5 from 'js-md5'
import rules from '@/mixins/rules.common'
import { getMyUserInfo, updateMyPassword } from '@/services'

export default {
  mixins: [rules],

  data() {
    return {
      oldPassword: null,
      newPassword: null,
      retypePassword: null,
      user: {},
      valid: false,
      retypePasswordRule: v => v === this.newPassword || '两次输入的密码不同'
    }
  },

  async beforeMount() {
    await this.fetchData()
  },

  methods: {
    async fetchData() {
      this.user = await getMyUserInfo()
    },

    async save() {
      let res = await updateMyPassword(md5(this.oldPassword), md5(this.newPassword))
      if (res) {
        global.showSuccess('密码更改成功')
      }
    }
  }
}
</script>
